import React from "react";
import PropTypes from "prop-types";

/**
 * Component stop propagate event to parent components
 */
const StopPropagation = ({ children }) => {
	const stopPropagation = React.useCallback(e => {
		e.stopPropagation();
	}, []);

	return <div onClick={stopPropagation}>{children}</div>;
};

StopPropagation.propTypes = {
	children: PropTypes.any
};

StopPropagation.defaultProps = {
	children: null
};

export default StopPropagation;
